/** @jsxImportSource theme-ui */
import { SemiTitle, Text, View } from "@bottlebooks/gatsby-design-system";
import { Trans } from "@lingui/macro";
import { useLingui } from "@lingui/react";
import { FragmentType, graphql, useFragment } from "~/gql";
import Scale from "../Scale/Scale";

const fragment = graphql(`
  fragment ProductColor on Product {
    apparentColor
    appearanceIntensity
  }
`);

export default function ProductColor({
  data,
}: {
  data: FragmentType<typeof fragment>;
}) {
  const product = useFragment(fragment, data);
  const { i18n } = useLingui();
  if (!product || !hasContent(data)) return null;
  const { appearanceIntensity, apparentColor } = product;
  return (
    <View>
      <SemiTitle>
        <Trans>Color</Trans>
      </SemiTitle>
      {apparentColor && (
        <Text sx={{ marginBottom: 2 }}>
          <Trans>Apparent color: {apparentColor}</Trans>
        </Text>
      )}
      <Scale
        text={
          <Trans>
            Intensity: {i18n._(`appearanceIntensity.${appearanceIntensity}`)}
          </Trans>
        }
        value={appearanceIntensity ? intensityScale[appearanceIntensity] : null}
        max={3}
        sx={{ maxWidth: 210 }}
      />
    </View>
  );
}

function hasContent(data: FragmentType<typeof fragment>) {
  const product = useFragment(fragment, data);
  if (product.appearanceIntensity) return true;
  if (product.apparentColor) return true;
  return false;
}
ProductColor.hasContent = hasContent;
const intensityScale: { [key: string]: number } = {
  pale: 1,
  medium: 2,
  deep: 3,
};
